/**
 * Default message parser that attempts to parse message data as JSON.
 */
export function parseMessage(message) {
  const parsedMessage = {
    message
  };
  if (typeof message.data === 'string') {
    try {
      const data = JSON.parse(message.data);
      parsedMessage.message = Object.assign({}, parsedMessage.message, {
        data
      });
    } catch (_unused) {
      // We're expecting JSON data for all messages, so if it's missing, ignore the message
      return;
    }
  }
  return parsedMessage;
}